module.exports = __webpack_public_path__ + "img/11.a6dbc73c.jpg";